import React from "react";

const NameSelector = ({ selectedName, setSelectedName }) => {
  const userNames = ["山田 太郎", "鈴木 花子", "佐藤 次郎"]; // サンプルの名前リスト

  return (
    <div className="name-selection">
      <label htmlFor="name">名前を選択してください:</label>
      <select
        id="name"
        value={selectedName}
        onChange={(e) => setSelectedName(e.target.value)}
      >
        <option value="">-- 選択してください --</option>
        {userNames.map((name, index) => (
          <option value={name} key={index}>
            {name}
          </option>
        ))}
      </select>
      {/* 自由入力の場合はこちらを有効に */}
      {/* <label htmlFor="name-input">名前を入力してください:</label>
      <input
        id="name-input"
        type="text"
        placeholder="名前を入力してください"
        value={selectedName}
        onChange={(e) => setSelectedName(e.target.value)}
      /> */}
    </div>
  );
};

export default NameSelector;
